import { SingletonRouter } from 'next/router';
import Merchant from '../../../domain/entities/Merchant';

interface ReservationUrl {
  url: string;
  targetBlank: boolean;
}

export const reservationUrlBy = (
  merchant: Merchant,
  router?: SingletonRouter,
): ReservationUrl => {
  // to setting url with explore setting.
  if (
    merchant.setting.isExploreOnly &&
    merchant.setting.exploreOnlyMerchantReservationPageUrl !== ''
  ) {
    return {
      url: merchant.setting.exploreOnlyMerchantReservationPageUrl,
      targetBlank: true,
    };
  }
  // for book detail page.
  if (router && router.query && router.query.resource_id) {
    const bookingPath = `/${merchant.publicId}/${router.query.resource_id}/book`;
    const queryString = router.asPath!.split(/\?/)[1];
    return {
      url: queryString ? `${bookingPath}?${queryString}` : bookingPath,
      targetBlank: false,
    };
  }
  // for others.
  return {
    url: `/${merchant.publicId}/booking_pages#pageContent`,
    targetBlank: false,
  };
};
